export const subtitles = {
    "1": {
        "startTime": 0.01,
        "endTime": 4.27,
        "transcript": "Enetangqerrluku atuusqumayaaqluku au͡gna ellakegtaar.",
        "translation": "With houses, we want them to take advantage of that good weather."
    },
    "2": {
        "startTime": 4.92,
        "endTime": 8.79,
        "transcript": "Un'gani cali qanrut'laranka unegkut ayagyuat.",
        "translation": "Down there, I also tell those young people down there."
    },
    "3": {
        "startTime": 9.49,
        "endTime": 13.57,
        "transcript": "Tua-i ilaita, qaill' tayima pilartatnga.",
        "translation": "Some of them, I'm not sure what they make of me."
    },
    "4": {
        "startTime": 13.585,
        "endTime": 19.275,
        "transcript": "Ilait tua-i niicugnilartut arulaiqapiaraucimtun.",
        "translation": "Some of them listen until I am completely finished."
    },
    "5": {
        "startTime": 20.085,
        "endTime": 25.805,
        "transcript": "Niicugnilartut niicugninqegcaarluteng tan'gaurluut nasaurluut-llu.",
        "translation": "The boys and the girls listen extremely well."
    },
    "6": {
        "startTime": 26.93,
        "endTime": 36.71,
        "transcript": "Tua-i ugkurluut-llu wii waniw' qanqenganka, tua-i mat'umek maa-i cali qalarut'laranka.",
        "translation": "And those poor people out there, I tell them about what I have just said."
    },
    "7": {
        "startTime": 37.305,
        "endTime": 42.545,
        "transcript": "Ayuqucirkaatnek qalarut'laryaaqanka.",
        "translation": "I do talk to them about how they should be."
    },
    "8": {
        "startTime": 43.08,
        "endTime": 49.29,
        "transcript": "Tua-i qaill' pingailameng, kiumrangailameng-llu niicugniurau͡rlularaatnga tua-i.",
        "translation": "Because though wouldn't do anything or talk back, the poor things listen to me."
    },
    "9": {
        "startTime": 49.45,
        "endTime": 55.25,
        "transcript": "Tayima-am iliit cali imna akwaugaq ayagaqurallruyaaqaanga maani.",
        "translation": "One of them also took me around here yesterday"
    },
    "10": {
        "startTime": 56.025,
        "endTime": 61.855,
        "transcript": "Tayima irniqatalriit eniitni uitauq.",
        "translation": "He stays at the house of someone who's about to give birth."
    },
    "11": {
        "startTime": 63.615,
        "endTime": 66.435,
        "transcript": "Taukut eniitni uitanilartuq.",
        "translation": "He says he stays at their house."
    },
    "12": {
        "startTime": 67.91,
        "endTime": 83.42,
        "transcript": "Tua-i-w' tangerrluku, au͡gkut ava-i angullrenka wii yuut arenqialnguut, maa-i kinguatgun ayuqiitnek, ayuqaitnek tangeqsailngua.",
        "translation": "Look, those struggling people that I was born in time to see, I never saw anyone else like them after."
    },
    "13": {
        "startTime": 83.64,
        "endTime": 88.18,
        "transcript": "Tang ak'arraurcaaqelria imna ellama nallunrillra.",
        "translation": "See, it's been a long time since I became aware."
    },
    "14": {
        "startTime": 88.435,
        "endTime": 104.965,
        "transcript": "Tang waniwa allrakunka-llu, allrakungellinilrianga yuinarnek cetamanek, ukut-wa allrakut qulen, ukut-llu qulen cipluteng pingayunek.",
        "translation": "You see, I am now 93 years old."
    },
    "15": {
        "startTime": 106.031,
        "endTime": 117.056,
        "transcript": "Waniwa tua-i cavkenii cali ingna May-aaq tekiskumu cetamaurciiqut ukut qulem cipneri.",
        "translation": "If I make it safely to May, I will turn 94."
    },
    "16": {
        "startTime": 119.275,
        "endTime": 124.55,
        "transcript": "Allrakut qulem cipneri.",
        "translation": "My age past 90."
    },
    "17": {
        "startTime": 128.219,
        "endTime": 136.819,
        "transcript": "Tua-i waniwa arenqiatua. Piniryuumiucaaqamcai cakneq, ayagyuani arcaqerluci.",
        "translation": "It's unfortunate now. I really wish to be strong for you, especially you young people."
    },
    "18": {
        "startTime": 136.976,
        "endTime": 141.126,
        "transcript": "Piniryuumiutepiaryaaqamci au͡g'umun ava-i.",
        "translation": "I wish that I could be strong for what I just said."
    },
    "19": {
        "startTime": 141.883,
        "endTime": 152.445,
        "transcript": "Assircaarluci yuurtesqelluci, qanruyuteci-llu caunrilkevkenaki. Atam maligtaquuraulluci yuurteqaqici.",
        "translation": "I want you to become good people, and do not disregard the wisdom passed to you. Become obedient people and see."
    },
    "20": {
        "startTime": 153.133,
        "endTime": 165.058,
        "transcript": "Atam maligtaquuraulluci yuureskuvci, elluarrluci yuurciiquci, qanruyutevceńun maligtaquuraulluci yuureskuvci.",
        "translation": "You, see if you become obedient people, you will become good people, if you become people who follow the wisdom passed to you."
    },
    "21": {
        "startTime": 165.671,
        "endTime": 168.446,
        "transcript": "Yuurciiquci assirluci.",
        "translation": "You will become good people."
    },
    "22": {
        "startTime": 169.514,
        "endTime": 182.764,
        "transcript": "Tua-i waten tang maligtaquterrlainanrilnge'rmi maligtaquurautelleq ukvertalleq-llu tua-i elluarrluni yuunarqellinilria.",
        "translation": "You see, even though one is not always obedient like this, being obedient and faithful leads to a good life."
    },
    "23": {
        "startTime": 182.796,
        "endTime": 187.183,
        "transcript": "Waniwa tang wani tua-i cau͡rlurpeceńi wani,",
        "translation": "Now, you see, in your poor state,"
    },
    "24": {
        "startTime": 187.683,
        "endTime": 193.621,
        "transcript": "Yugmek-llu pinerrlugtestemnek tangerrpailegma waten waniw' elliutekluku.",
        "translation": "And before I saw anyone who wronged me, I've become like this."
    },
    "25": {
        "startTime": 194.359,
        "endTime": 196.309,
        "transcript": "Tua-i waniwa.",
        "translation": "Here I am."
    },
    "26": {
        "startTime": 196.916,
        "endTime": 202.566,
        "transcript": "Kia imum qancurlaupailganga waten waniw' ellirlua.",
        "translation": "Before anyone said harmful words to me, I've become like this."
    },
    "27": {
        "startTime": 203.948,
        "endTime": 211.073,
        "transcript": "Tua-i ca tamalkuan pitaciluku waniw' tangvagcetlemkun.",
        "translation": "I treated everything the same through having you watch me."
    },
    "28": {
        "startTime": 211.654,
        "endTime": 218.754,
        "transcript": "Pitaciluku ca tamalkuan mikelnguukevkenaku qarulluku piurallra assirtuq.",
        "translation": "It's good to treat everyone the same without thinking them of them as children, and encouraging them."
    },
    "29": {
        "startTime": 220.148,
        "endTime": 229.198,
        "transcript": "Atam, atam tuaten tau͡gaam yuk ayuqelria elluarrluni agaurkaullinilria.",
        "translation": "You see, only a person who is like that will go through life well."
    },
    "30": {
        "startTime": 229.68,
        "endTime": 244.205,
        "transcript": "Tuaten-llu qaillun pillerkaminun tekiteksaunani, wall'u picurlallerkaminun, pinerrlugcimallerkaminun-llu tekiteksaunani ag'urararkaullinilria.",
        "translation": "And like that, he will not come to anything, or accidents, and he will keep going without coming to being treated badly."
    },
    "31": {
        "startTime": 244.724,
        "endTime": 250.411,
        "transcript": "Tuaten elluarrluni piuralria, maligtaquurautellria tau͡gaam.",
        "translation": "Only one who is just, who is obedient."
    },
    "32": {
        "startTime": 251.149,
        "endTime": 260.499,
        "transcript": "Maligtaquurautellria, qanruyutni caunrilkevkenaki aturtu'rqiit tuaten ayuqerkaulliniuq.",
        "translation": "An obedient person who does not disregard traditional wisdom, but applies them, will be like that."
    },
    "33": {
        "startTime": 261.293,
        "endTime": 269.456,
        "transcript": "Waniw' wangkuk call' imna-ll' aipau͡rluqa-ll' aipaqutellruukuk navguutevkenanuk.",
        "translation": "My dear husband and I were married without being abusive."
    },
    "34": {
        "startTime": 270.618,
        "endTime": 282.256,
        "transcript": "Wii tua-i umyuaqa navegyaaqellrua, tau͡gaam wiinga imkunritaqa, tuaten elliitun ayuqutenritaqa.",
        "translation": "He did break my heart, but I didn't, you know, do the same to him."
    },
    "35": {
        "startTime": 283.306,
        "endTime": 288.244,
        "transcript": "Cunaw' tang waniw' ciullekanga tayima anirtaarutkaqa.",
        "translation": "It had turned out that it would be a good thing if he passed before me."
    },
    "36": {
        "startTime": 288.444,
        "endTime": 294.119,
        "transcript": "Anirta tuaten wii ayuqellrulliniunga umyuaqa navellrungraaku.",
        "translation": "It's a good thing I was like that even though he had broken my heart."
    },
    "37": {
        "startTime": 295.45,
        "endTime": 301.238,
        "transcript": "Anirta tuaten wii ayuqellrunritliniunga umyuaqa navellrungraaku.",
        "translation": "It's a good thing that I wasn't like that even though he had broken my heart."
    },
    "38": {
        "startTime": 301.963,
        "endTime": 306.226,
        "transcript": "Tua-i waniw' anirtaarutekluku man'a tekilluku.",
        "translation": "I still think that's a good thing to this day."
    },
    "39": {
        "startTime": 307.063,
        "endTime": 309.313,
        "transcript": "Tang cali waniwa:",
        "translation": "See, here's another thing:"
    },
    "40": {
        "startTime": 309.532,
        "endTime": 326.232,
        "transcript": "Maani tua-i imkunek au͡gna ciuqliq ilaitnek-llu yuut kinguvarrluku piunrilkelluku-llu qanelrianek niitaqama,",
        "translation": "The first here, when I hear about people putting down others and treated them badly,"
    },
    "41": {
        "startTime": 326.476,
        "endTime": 335.401,
        "transcript": "Wiinga tang tua-i au͡gna ciuqliq tua-i piunritenrituq, piunricugnaituq.",
        "translation": "You see, that first one is not untrue, it's definitely not untrue."
    },
    "42": {
        "startTime": 336.045,
        "endTime": 346.307,
        "transcript": "Atam umyuaqelaqeka imna Jesus-aam qanellra waten pilrianek niitaqama, waten qanellra:",
        "translation": "You see, I remember what Jesus said when I hear about people doing this, when he said this:"
    },
    "43": {
        "startTime": 347.108,
        "endTime": 357.533,
        "transcript": "Ellii-gguq waniw' man'a alerquun piunrirrluku tekitenrituq, tau͡gaam-gguq qaqicarturluku.",
        "translation": "He said that he did not come to destroy this commandment, but to fulfill it."
    },
    "44": {
        "startTime": 357.789,
        "endTime": 369.902,
        "transcript": "Tang. Tangerrluku nutaan piunrirciarkam taum piunrurtellrunritaa carraungraan ciuqliit ayuqucillrat alerquutiit-llu.",
        "translation": "You see? See that the one with the authority to destroy it, did not destroy even a little of the first customs and commandment."
    },
    "45": {
        "startTime": 370.302,
        "endTime": 373.939,
        "transcript": "Piunrircimallrunrituq watqapik.",
        "translation": "It was not destroyed in the least."
    },
    "46": {
        "startTime": 374.639,
        "endTime": 380.489,
        "transcript": "Tua-i umyuaqela'arqa waniwa umyuaqkacagarluku.",
        "translation": "I think of it now very clearly."
    },
    "47": {
        "startTime": 381.083,
        "endTime": 385.533,
        "transcript": "Waqaa waniwa-qaa uicung' taqnariksaitaanga?",
        "translation": "Well, is it time for me to stop, cousin?"
    },
    "48": {
        "startTime": 385.602,
        "endTime": 387.278,
        "transcript": "Tua-i taqnariaten.",
        "translation": "It's time for you to stop."
    },
    "49": {
        "startTime": 387.278,
        "endTime": 391.665,
        "transcript": "Kitaki taqnarillrani uitaqerci.",
        "translation": "Okay, please stay now that it's time to end."
    },
    "50": {
        "startTime": 392.44,
        "endTime": 403.903,
        "transcript": "Uitaqerci. Nallunrilkengaqa au͡gna umyuaqelaqengaqa cali makunun ayagyuanun niigarcetqernauqa qanruyun, ai?",
        "translation": "Please stay. Let me tell these young people about the traditional wisdom that I know and think of, okay?"
    },
    "51": {
        "startTime": 403.99,
        "endTime": 404.603,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "52": {
        "startTime": 404.79,
        "endTime": 412.978,
        "transcript": "Kitaki. Waniwa piciulria taringumariluku:",
        "translation": "Okay now. Understand this truth:"
    },
    "53": {
        "startTime": 413.278,
        "endTime": 422.478,
        "transcript": "Pitsaqutmek assiilngiqumta assiilnguput cimiutekairuciiqut,",
        "translation": "If we intentionally sin, our sins will have no more chances of forgiveness,"
    },
    "54": {
        "startTime": 422.997,
        "endTime": 430.609,
        "transcript": "Tau͡gaam ciunerkarluta irranarqelriamek qanercetaarutmek,",
        "translation": "But in our future there is a great trial,"
    },
    "55": {
        "startTime": 431.623,
        "endTime": 445.648,
        "transcript": "Kenermek-llu alingnarqelriamek narurcilriit piunriutekaatnek, Hebrews 10:26.",
        "translation": "And a frightening fire for the destruction of the sinners, Hebrews 10:26."
    },
    "56": {
        "startTime": 445.917,
        "endTime": 448.467,
        "transcript": "Nutaan taq'uq ava-i.",
        "translation": "Now it's done."
    },
    "57": {
        "startTime": 448.861,
        "endTime": 451.136,
        "transcript": "Yaa, quyana. (Pellugtuq.)",
        "translation": "Yes, thank you. (It's done.)"
    },
    "58": {
        "startTime": 452.98,
        "endTime": 454.592,
        "transcript": "Kitak' tua-i, nuu.",
        "translation": "That's all, no."
    },
    "59": {
        "startTime": 457.268,
        "endTime": 461.118,
        "transcript": "Ellamun aneksaituq qula malrugnek cass'arrluni.",
        "translation": "He did not go out for twelve hours."
    },
    "60": {
        "startTime": 463.562,
        "endTime": 470.437,
        "transcript": "Enem iluani tarritaqami mat'umek cuplumek wavet kapusngaluni tarriterrlainarluni.",
        "translation": "When she walked around the house, she would always walk with a tube attached here."
    },
    "61": {
        "startTime": 470.468,
        "endTime": 472.518,
        "transcript": "Wangkuk waniw' aipaqa-llu.",
        "translation": "Here's my spouse and I."
    },
    "62": {
        "startTime": 472.662,
        "endTime": 480.887,
        "transcript": "Pingayunek tau͡gaam iralurrluni yuullruuq tauna tuatnalria nallumegni wangkuk.",
        "translation": "But the one who was like that lived for three months without our knowledge."
    },
    "63": {
        "startTime": 481.118,
        "endTime": 489.056,
        "transcript": "??Man'a neqpik akaurtelleq nallunrilkii maa-i akissulriit nunamteńi uitalriit.",
        "translation": "??It's been a long time since those who are in our lands fish salmon for money."
    },
    "64": {
        "startTime": 489.493,
        "endTime": 497.643,
        "transcript": "Maa-i neqetgun 1976, maani Kusquqvagmi Kuigpiim-ll' paiyartuani yuvrillrit.",
        "translation": "Through the fish in 1976, here is what they studied here on the Kuskokwim and near the mouth of the Yukon."
    },
    "65": {
        "startTime": 499.118,
        "endTime": 502.868,
        "transcript": "Wangkuta Yupiuniluta ukut Kass'at nalqigucuitaitkut.",
        "translation": "These Causcasians do not tell us because we're Yup'ik."
    },
    "66": {
        "startTime": 505.831,
        "endTime": 507.93,
        "transcript": "Cali waniw' qanruyutii:",
        "translation": "It also says this:"
    },
    "67": {
        "startTime": 508.859,
        "endTime": 515.35,
        "transcript": "Mat'um-gguq imum mercury-mek pilallrata, camani kuiget...",
        "translation": "It says that what they call mercury, down in the rivers..."
    },
    "68": {
        "startTime": 515.422,
        "endTime": 523.758,
        "transcript": "Matthew, uumek qanresqellruyaaqamteggen: waste and spills (?)",
        "translation": "Matthew, we asked you to speak about this: waste and spills (?)"
    },
    "69": {
        "startTime": 523.887,
        "endTime": 527.81,
        "transcript": "Tauna kingumek ping'erpeni cangaiciiquq.",
        "translation": "It'll be fine if you do that later."
    },
    "70": {
        "startTime": 527.996,
        "endTime": 529.63,
        "transcript": "Time-arput una piuq.",
        "translation": "Our time is running out."
    },
    "71": {
        "startTime": 529.702,
        "endTime": 530.808,
        "transcript": "Ak'anun pingaituq.",
        "translation": "It won't take long."
    },
    "72": {
        "startTime": 530.834,
        "endTime": 536.536,
        "transcript": "Tamaa-i tamana kangia ciumek nalqigutnaluku, tamana maa-i caliama kangia.",
        "translation": "I first wanted to explain that means, what my work means."
    },
    "73": {
        "startTime": 537.811,
        "endTime": 544.695,
        "transcript": "Maa-i waniwa kiirrarma imucetun qau͡gyami ceńami uitalriami atauciq kanevnerrartun uitaunga.",
        "translation": "I am now alone like a piece of debris on the sand on the shore."
    },
    "74": {
        "startTime": 544.728,
        "endTime": 550.363,
        "transcript": "Waten nalqigucaaqaqama asgurilua yuut waten arulairtengnaqlaraatnga.",
        "translation": "When I explain it, people doubt me and try to stop me like this."
    },
    "75": {
        "startTime": 550.71,
        "endTime": 557.739,
        "transcript": "Tau͡gaam wangkuta taringumakumta tayima aipaagni waten yup'ut ayuqluki waten uitayanritukut.",
        "translation": "But if we understood, our people probably would not be like this."
    },
    "76": {
        "startTime": 558.766,
        "endTime": 565.343,
        "transcript": "Maa-i-gguq tamatum neqemta, wangkuta neqpiim nallum pillrata",
        "translation": "They say that because our fish now, since our fish are like this unbeknownst to us"
    },
    "77": {
        "startTime": 565.728,
        "endTime": 569.19,
        "transcript": "Ner'aqamteki, makut tenguut arcaqerluki",
        "translation": "When we eat them, especially their livers"
    },
    "78": {
        "startTime": 571.334,
        "endTime": 578.19,
        "transcript": "Arnaq una neqpigmek nerumaluni tamakunek assinrilngurnek wangkuta nalluluki",
        "translation": "When a woman eats salmon with those bad things we don't know about"
    },
    "79": {
        "startTime": 578.56,
        "endTime": 580.858,
        "transcript": "Makut aipaimta taringumanritellret",
        "translation": "Our counterparts who do not understand"
    },
    "80": {
        "startTime": 580.886,
        "endTime": 587.059,
        "transcript": "Wiinga tua-i yugnek caliangqertua ayaglua",
        "translation": "I travel working with people"
    },
    "81": {
        "startTime": 587.225,
        "endTime": 592.946,
        "transcript": "Aipau͡rluqa unitaarluku irniapuk pingraata.",
        "translation": "I repeatedly leave my wife despite our children."
    },
    "82": {
        "startTime": 593.127,
        "endTime": 595.56,
        "transcript": "Taumek picirluku wavet taivkaraqa.",
        "translation": "That's the reason I'm bringing it up."
    },
    "83": {
        "startTime": 596.3,
        "endTime": 598.242,
        "transcript": "Maa-i cali taqeksaunani.",
        "translation": "It still hasn't stopped now."
    },
    "84": {
        "startTime": 599.631,
        "endTime": 604.631,
        "transcript": "Tauna tang unakekumku maa-i camek unakutellriatun piciqua.",
        "translation": "If I get that, it will be like I have gotten something."
    },
    "85": {
        "startTime": 605.21,
        "endTime": 611.855,
        "transcript": "Nallumteńi neqpimteggun makut akissulriit uqlautiitgun navgullratnek makut neqput",
        "translation": "With the destruction of our salmon without our knowledge through the pollution of those looking for profit"
    },
    "86": {
        "startTime": 612.665,
        "endTime": 624.028,
        "transcript": "Una-gguq yugkaq qamani qingauluni kanangqatulliniami una umyuarkaa navgurlallinia.",
        "translation": "They say that because this fetus inside is upside down, it destroys his brain."
    },
    "87": {
        "startTime": 624.515,
        "endTime": 626.563,
        "transcript": "Qaqisngavkenani tau͡gken yuurrluni.",
        "translation": "Yet he is born underdeveloped."
    },
    "88": {
        "startTime": 626.749,
        "endTime": 633.374,
        "transcript": "Tua-i-llu wangkuta waniwa yuungnaqutem utumaqallerkaanun qanaaqatartua.",
        "translation": "And now, I am going to speak so that our survival will improve."
    },
    "89": {
        "startTime": 633.858,
        "endTime": 641.464,
        "transcript": "Tamana pitekluku ayaganguallranirpak arulaiyuunii aqumnanrirlua",
        "translation": "Because of that, I started traveling a lot without stopped and rarely sat."
    },
    "90": {
        "startTime": 642.151,
        "endTime": 649.361,
        "transcript": "Ukuk tau͡gaam ONC-nkuk AVCP-m maani nunarpagni qavartalqa nerumalqa-ll' akilirluku",
        "translation": "But ONC and AVCP paid for my lodging and meals here in the city"
    },
    "91": {
        "startTime": 649.506,
        "endTime": 652.941,
        "transcript": "Akimek-llu wangnek umyuarteqeksaunii.",
        "translation": "And I didn't think of money for myself."
    },
    "92": {
        "startTime": 653.716,
        "endTime": 657.949,
        "transcript": "Yuut tau͡gaam maani utumaqallerkaat pitekluku.",
        "translation": "It was only so that people here would get better."
    },
    "93": {
        "startTime": 658.338,
        "endTime": 663.818,
        "transcript": "Tua-llu man'a waten mikelngucuarauluni anngami tumarngavkenani.",
        "translation": "And then when a child is born like this, he is underdeveloped."
    },
    "94": {
        "startTime": 663.83,
        "endTime": 666.213,
        "transcript": "Cunaw' qamani umyugaan iluani.",
        "translation": "It turns out its inside in his brain."
    },
    "95": {
        "startTime": 666.423,
        "endTime": 672.338,
        "transcript": "Maa-i inerquraqamteki makut mikelnguut umyuarteqsaurtut:",
        "translation": "Now, when we admonish these children, they've started thinking:"
    },
    "96": {
        "startTime": 672.807,
        "endTime": 676.866,
        "transcript": "\"Ciin-kiq uum taumek inerqurtanga?\"",
        "translation": "\"I wonder why he's admonishing me against that?\""
    },
    "97": {
        "startTime": 676.898,
        "endTime": 683.404,
        "transcript": "Kangia-ll' tayima wangkuta nalqigutellanrilkeput qayuw' akniruteklerkaa tamatum paqnakluku.",
        "translation": "We probably don't explain the origin of that, curious about how that is harmful."
    },
    "98": {
        "startTime": 683.424,
        "endTime": 692.027,
        "transcript": "Paqnakaqamiu taangauluku-llu taangaq, puyuqcaqumek unuaquani tupagciqut qamiqiqcuaqerluteng, atakuani-ll' segg'arluteng.",
        "translation": "When they are curious about it, even alcohol and marijuana, they will wake up with a slight headache and be wide awake that evening."
    },
    "99": {
        "startTime": 692.864,
        "endTime": 698.5,
        "transcript": "Tamaa-i tamana navguutii wangkuta ayagyuamta.",
        "translation": "That is what destroys our young people."
    },
    "100": {
        "startTime": 699.185,
        "endTime": 703.503,
        "transcript": "Tau͡gaam waniwa ciumutmun eglenga'artellriatun eglengua.",
        "translation": "But now, it's as if I am going forward."
    },
    "101": {
        "startTime": 703.624,
        "endTime": 709.637,
        "transcript": "Maani Alaska-mi yumteńun ukunun-llu anguyagteńun pingramku niicunrilatnga.",
        "translation": "Because even though I bring it up to our people here in Alaska and to the governement, they don't listen to me."
    },
    "102": {
        "startTime": 709.757,
        "endTime": 717.588,
        "transcript": "Akmavet allamun nunamun ayaglua ikayungcallruunga elitnauristellguteklemnek.",
        "translation": "I went to another place out of state to ask for help from my former fellow teacher."
    },
    "103": {
        "startTime": 718.456,
        "endTime": 720.619,
        "transcript": "Eliin taum aulukciqaitkut.",
        "translation": "He will take care of us."
    },
    "104": {
        "startTime": 720.801,
        "endTime": 729.641,
        "transcript": "Cali ilaci tangellruarci tayima kiani Qaariitaarviim kanani-ll' Uivigmi",
        "translation": "You've probably also seen one of you up there in October and in December"
    },
    "105": {
        "startTime": 730.476,
        "endTime": 740.166,
        "transcript": "Wani KYUK-m TV-ani yaani cali Iralull'e'rmi, mat'um-llu Kanryaucim pit'ellrani cali yaani Anchorage-akun tangerrluku",
        "translation": "Here on KYUK TV, and you've seen it in January and the beginning of February"
    },
    "106": {
        "startTime": 740.186,
        "endTime": 748.796,
        "transcript": "Ataku-gguq cali malrunleget pingayunelgen-llu akuliini wani KYUK-mi tauna ataam tangercetenqigciiqaat.",
        "translation": "They said that they would show that again between 12 and 8 on KYUK."
    },
    "107": {
        "startTime": 748.806,
        "endTime": 751.366,
        "transcript": "Ellait ellmeggni tayim' arcaqaat.",
        "translation": "It is important to them."
    },
    "108": {
        "startTime": 751.641,
        "endTime": 757.861,
        "transcript": "Waniwa-ll' uku'urluuk malruulutek cali waniwa tamana umyuaqluku tarenrairaatnga.",
        "translation": "And now, these two dear people are recording me with that in mind."
    },
    "109": {
        "startTime": 757.866,
        "endTime": 760.766,
        "transcript": "Tayima aipaagni iliitni ataam alairciquq.",
        "translation": "It will probably show sometime again."
    },
    "110": {
        "startTime": 761.701,
        "endTime": 770.041,
        "transcript": "Wangkuta yup'ut ataam elluatmun eglerteqanillerkaa pitekluku man'a aqumnanriutekaqa.",
        "translation": "In order for our people to go forth well, I am not sitting for this anymore."
    },
    "111": {
        "startTime": 770.316,
        "endTime": 776.586,
        "transcript": "Watua nallum tau͡gaam waten ayuqlircetliniaput.",
        "translation": "We have unknowingly allowed it to become like this."
    },
    "112": {
        "startTime": 777.726,
        "endTime": 782.846,
        "transcript": "Tamana umyuakun aknirutngulallinian ayuqevkenani",
        "translation": "Since that is harmful to the mind in different ways"
    },
    "113": {
        "startTime": 782.911,
        "endTime": 790.501,
        "transcript": "Yuk cali kayutatkevkenani yuulaami ilii tukniluku aulukluku, iliin-llu cakneq aknirutekevkenaku.",
        "translation": "Since people live with varying strengths, some of them are strongly affected, and some are not harmed much."
    },
    "114": {
        "startTime": 790.961,
        "endTime": 799.431,
        "transcript": "Maa-i au͡gkut ciuliallernek qanenritua, tau͡gaam maa-i watua yuumta arcaqerluki makut aknirutait ayagyuamta",
        "translation": "I am not speaking of our ancestors right now, but especially what our people, our people, are harmed by"
    },
    "115": {
        "startTime": 799.561,
        "endTime": 802.151,
        "transcript": "Elpeceńun taringevkangnaqluki.",
        "translation": "To try to help you understand."
    },
    "116": {
        "startTime": 802.251,
        "endTime": 814.171,
        "transcript": "Avani uitallerkamteńi utumaqanitmun ataam cali maaken nunami tangrruunrirpailegma tangerrsugyaakluku utumatmun eglerrluki.",
        "translation": "So that we they will become better in our future, I want to see them go forth better before I am gone from this earth."
    },
    "117": {
        "startTime": 814.366,
        "endTime": 821.166,
        "transcript": "Tamakut umyuamegteggun aknircimalriit ayagmek maa-i qarulluki tau͡gaam maa-i caliukut.",
        "translation": "Now, we are only working to encourage those who have been mentally hurt from the beginning."
    },
    "118": {
        "startTime": 821.411,
        "endTime": 831.391,
        "transcript": "Makut amllerem Kass'am ilunguteksunritaa, wangkuta Yup'igni tau͡gaam, akingutekngamegtekut.",
        "translation": "Many Caucasians do not have any enthusiasm for that, only we Yupiit, because they profit off of us."
    },
    "119": {
        "startTime": 831.836,
        "endTime": 840.836,
        "transcript": "Atam uum calistai amllertut social worker-aatgun, tegustetgun, apauristetgun, tengssuutetgun, yungcaristetgun katurrluni.",
        "translation": "You see, they have a lot of workers, social workers, police, interrogators, planes, and health care workers all gathered."
    },
    "120": {
        "startTime": 841.181,
        "endTime": 849.761,
        "transcript": "Maa-i-gguq taangam taum kiimi, allat, allam naulluutem pivkenaki",
        "translation": "They say that now, alcohol is the only one, not other ailments"
    },
    "121": {
        "startTime": 849.826,
        "endTime": 858.816,
        "transcript": "Three hundred million dollars cipnenguq yugnun, state-am cagmarillra yugnun calilrianun akikun.",
        "translation": "The state has lost over $300 million to those working for the people."
    },
    "122": {
        "startTime": 859.016,
        "endTime": 866.096,
        "transcript": "Tamana caliarteng tamarillerkaat cagmaarillerkameggnek pitekluku ilunguteksunritait.",
        "translation": "They are not enthusiastic because they would lost a lot with their work."
    },
    "123": {
        "startTime": 866.141,
        "endTime": 872.261,
        "transcript": "Maani cali nallunritaci maa-i makut tunialriit arulairciigatait",
        "translation": "Here, you know that they cannoy stop those who sell"
    },
    "124": {
        "startTime": 872.326,
        "endTime": 877.916,
        "transcript": "Ilungutekluki caliaqenrilamegteki kankut tegustet akikutekngamegteki.",
        "translation": "Since the police down there do not work hard on them since it is a source of income."
    },
    "125": {
        "startTime": 878.696,
        "endTime": 885.116,
        "transcript": "Taumek picirlua, ukut waniwa amllerrsaaqut kalikat nalqigutai uum",
        "translation": "That's why, there may be a lot of explanations on this paper"
    },
    "126": {
        "startTime": 886.421,
        "endTime": 894.281,
        "transcript": "Maani calinriama makut ayagyuanka, ayagyuaput tangerrluki aqumnanrirtua arcaqerlua.",
        "translation": "Since I am not working here anymore, I am personally not sitting for my young people, our young people."
    },
    "127": {
        "startTime": 896.106,
        "endTime": 908.526,
        "transcript": "Aipaagni makut ayagyuaci tamatumek science-amek elitnaurluki kayemkuvciki tayima",
        "translation": "Maybe if you teach and push your young people toward science"
    },
    "128": {
        "startTime": 908.831,
        "endTime": 914.731,
        "transcript": "Ataucirrarmek Yupiarmek kangingqenrilkuni tukniriciquq.",
        "translation": "If it does not hold meaning for a single Yup'ik, it will get worse."
    },
    "129": {
        "startTime": 914.776,
        "endTime": 922.886,
        "transcript": "Atam uum Kass'am eglerutellra: piqamek watua niigarcuitaikut, taq'inermek tau͡gaam.",
        "translation": "See what the Caucasians have brought forth: they are not readily available to listen to us, only telling us to quit."
    },
    "130": {
        "startTime": 925.466,
        "endTime": 927.446,
        "transcript": "Niicaqlirluta niit(aqluta).",
        "translation": "They only listen once in a while."
    },
    "131": {
        "startTime": 927.491,
        "endTime": 934.151,
        "transcript": "Maa-i waniwa tangvallemni uitanqegciriinanritut, qacigtenririinartut.",
        "translation": "From what I see now, they are not getting more peaceful, not getting easier."
    },
    "132": {
        "startTime": 934.586,
        "endTime": 947.576,
        "transcript": "Tamatumek picirluki makut neqpiit maani Akulmi makuk-llu Kuigpiik akuliigni arcaqerluku wangkuta aknirumanruukut ilamteńi maani nunamteńi state-ami.",
        "translation": "Becuase of these salmon, those of us here between Akula and the Yukon are the most harmed than our fellow people here in our state."
    },
    "133": {
        "startTime": 948.366,
        "endTime": 955.576,
        "transcript": "Nallumteńi tamaani akemkut akissulriit uqlautiitnek wangkuta tamakut neqpiput nerlalliniameng",
        "translation": "Because our salmon are eating the pollution from those making profit unbeknownst to us"
    },
    "134": {
        "startTime": 955.716,
        "endTime": 968.466,
        "transcript": "Man'a-ll' akunlemteńi ungungssit tayima tamana tuvtaarluteng makut kuipiaq uryuraqami pavavet enutaqatki tayim' naunrarteggun-llu nerlaqait tamakut neqpiit.",
        "translation": "And between us, the animals probably choke on things and eat the salmon among the plants when the main river floods inland then goes out."
    },
    "135": {
        "startTime": 969.156,
        "endTime": 980.176,
        "transcript": "Tua-i cuvrirtekaitnek cat imkut, arcaqerluki tamakut aulukuciitnek kaigateklaryaaqanka.",
        "translation": "I do request them for researchers for those, especially how those are taken care of."
    },
    "136": {
        "startTime": 980.181,
        "endTime": 984.911,
        "transcript": "Tau͡gaam uum Switzerland-akun ikayurtengciqngatukut.",
        "translation": "It I think we will get help from Switzerland."
    },
    "137": {
        "startTime": 984.911,
        "endTime": 994.761,
        "transcript": "Man'a ellam aulukucia naulluutemteńun kanamalria maa-i kiagpak alairciiqaat.",
        "translation": "This summer, they will present taking care of the earth in relation to our ailments."
    },
    "138": {
        "startTime": 994.851,
        "endTime": 1001.421,
        "transcript": "Malruurteqatartuk allrakuk wani Mamterillermun tekilluteng malrugni Maqinerni yuvrillrat",
        "translation": "It's going to be two years since they've come to Bethel and researched for two weeks"
    },
    "139": {
        "startTime": 1001.421,
        "endTime": 1005.991,
        "transcript": "Pau͡gna ellavet pavavet-ll' akunlemteńun ayagluteng naunrat cali yuvrirluki.",
        "translation": "Also going inland to nature aroudn us and examining the plants."
    },
    "140": {
        "startTime": 1006.911,
        "endTime": 1018.391,
        "transcript": "Tamaa-i tamakut man'a caliarput elluatmun eglertellemteńek kangii taqsaquteksaunaki, tau͡gaam egmiulluki.",
        "translation": "Do not tire of the sources of our work to improve us going forward, but continue them."
    },
    "141": {
        "startTime": 1018.606,
        "endTime": 1024.816,
        "transcript": "Piyaqlirluteng niitelalliniut ukut, arcaqerluteng aipaiput.",
        "translation": "They only listen once in a while, especially our counterparts."
    },
    "142": {
        "startTime": 1025.196,
        "endTime": 1032.876,
        "transcript": "Man'a maa-i ilungutiit: man'a nunavut calligcimanrilnguq camani uitalria tukuuteput.",
        "translation": "Here is what they strive for: our riches down in our pristine lands."
    },
    "143": {
        "startTime": 1033.411,
        "endTime": 1039.891,
        "transcript": "Arcaqerluku tamana pitekluku wangkuta pamateksunritaitkut.",
        "translation": "That is the main reason that they do not cooperate with us."
    },
    "144": {
        "startTime": 1040.206,
        "endTime": 1048.606,
        "transcript": "Cali nallunrituci elitnautullerni akmani imkut ingqilut uuggun pitgarluki nut'galuteng-ll' ikegglillruit.",
        "translation": "You who have gone to school also know that they shot arrows and guns at the Native Americans and reduced their populations."
    },
    "145": {
        "startTime": 1048.771,
        "endTime": 1061.451,
        "transcript": "Maa-i wangkuta tamakutgun ellam mat'um-ll' nunam navguutaitgun tamakunek caskirluteng maa-i wangkuta ikeglingnaqkaitkut.",
        "translation": "Now, they utilize those, the destruction of the nature and land around us, to reduce our population."
    },
    "146": {
        "startTime": 1061.591,
        "endTime": 1063.631,
        "transcript": "Amlleriinarpek'nata-llu.",
        "translation": "And our population isn't increasing."
    },
    "147": {
        "startTime": 1063.986,
        "endTime": 1066.506,
        "transcript": "Una cali miilicaaq apurarpek'naku.",
        "translation": "We also don't reach a million."
    },
    "148": {
        "startTime": 1066.871,
        "endTime": 1074.511,
        "transcript": "Atam nunanun ayallrulrianga pingayunlegen miilicaat apurluki yul'egmek, ataucirraq nuna.",
        "translation": "You see, I traveled to a place that reached a population of eight million, a single city."
    },
    "149": {
        "startTime": 1075.006,
        "endTime": 1082.276,
        "transcript": "Qayuw' wiinga Yupiarulua tuacetun kanevnerrartun ceńami qau͡gyatun ayuqellriatun wii ayuqellrianga.",
        "translation": "As a Yup'ik, it was as if I were a single piece of sand on the shore."
    },
    "150": {
        "startTime": 1082.296,
        "endTime": 1085.316,
        "transcript": "Casciigatellruama taumek picirlua ciumek qanellruunga.",
        "translation": "Because I was helpless, I said that first."
    },
    "151": {
        "startTime": 1085.341,
        "endTime": 1088.781,
        "transcript": "Ilangqertua qaneryugarkanek tayima. Quyana niicugniluci.",
        "translation": "I have peers who would like to speak. Thank you for listening."
    },
    "152": {
        "startTime": 1090.086,
        "endTime": 1093.246,
        "transcript": "Waten ayuqellrunrilama avani kinguqvani",
        "translation": "Because I wasn't like this a long time ago"
    },
    "153": {
        "startTime": 1093.351,
        "endTime": 1101.141,
        "transcript": "Waten qanraqama-llu tua-i kinguakun ciinllugguaralaama qanllemnek.",
        "translation": "Also because I would regret what I said after I speak."
    },
    "154": {
        "startTime": 1101.421,
        "endTime": 1109.041,
        "transcript": "Waten tang elli'irrluni qanllerkaq man'a caperrnairut'laryaaqellinilria.",
        "translation": "It turns out that becoming this age, it gets less difficult to speak."
    },
    "155": {
        "startTime": 1109.336,
        "endTime": 1113.976,
        "transcript": "Wiingau͡rluq ava-i ayuqucillemnek niiquryaaqua.",
        "translation": "Poor me, I just listened to what I was like."
    },
    "156": {
        "startTime": 1114.751,
        "endTime": 1124.061,
        "transcript": "Tau͡gaam wiinga cali imumi au͡g'um qanrutestema natermiutaullruama-llu inarrvillraagnek tua-i",
        "translation": "But my teacher back then, because I stayed on the floor on a mattress"
    },
    "157": {
        "startTime": 1124.221,
        "endTime": 1129.351,
        "transcript": "Anvailegma im' qanrutestema qalarutetullruanga kesianek pinrilnge'rma.",
        "translation": "Before I went out, my teacher would speak to me even if it wasn't all the time."
    },
    "158": {
        "startTime": 1131.261,
        "endTime": 1134.541,
        "transcript": "Man'a yuullerkaqa arcaqerluku qanrutek'laraa.",
        "translation": "He would mainly speak to me about how I should live."
    },
    "159": {
        "startTime": 1135.866,
        "endTime": 1142.546,
        "transcript": "Tau͡gaam wiinga aturarkaunrilnguq niicugniuralallruaqa pektesciigalilua-llu.",
        "translation": "But I would listen to what we shouldn't do and I wouldn't be able to move."
    },
    "160": {
        "startTime": 1143.901,
        "endTime": 1146.631,
        "transcript": "Mat'umek yuullerkamnek qanrut'lallruanga.",
        "translation": "He would speak to me about how I should live."
    },
    "161": {
        "startTime": 1147.801,
        "endTime": 1153.381,
        "transcript": "Aturarkaunrilngurmek ava-i qanertua. Niicugniuralallruaqa.",
        "translation": "I just talked about what we shouldn't do. I used to listen to him."
    },
    "162": {
        "startTime": 1155.246,
        "endTime": 1163.766,
        "transcript": "Au͡g'um tang qanraqami yullret au͡gkut qanrutketullrukai naulluulriartaitelallruniluku.",
        "translation": "When he spoke, he would say that the people long ago would have no sicknesses."
    },
    "163": {
        "startTime": 1165.611,
        "endTime": 1176.151,
        "transcript": "Cali-llu-gguq caqapigtellria tayima nunani yaaqvani-llu catairutaqami, ima-llu-gguq-qaa pektellra taum yuum cukakuni",
        "translation": "Also, he said that when someone passed away once in a while in faraway villages, if there was a nimble person"
    },
    "164": {
        "startTime": 1179.416,
        "endTime": 1185.786,
        "transcript": "Tauna-gguq tekitaqan allaneq qanemciluni-llu tauna yuunrirniluku nani tayim' yaaqvani nunani",
        "translation": "He said that when that visitor arrived and said that someone from a faraway village had passed away"
    },
    "165": {
        "startTime": 1187.026,
        "endTime": 1192.716,
        "transcript": "Nunat-gguq taukut qiatullruat, nepliatullruat.",
        "translation": "He said that that village would cry and grieve loudly over him."
    },
    "166": {
        "startTime": 1194.066,
        "endTime": 1197.156,
        "transcript": "Waten-llu ciin qanerta? Maa-i elitaq'la'rqa.",
        "translation": "I wonder why he said this? I recognize it now."
    },
    "167": {
        "startTime": 1197.966,
        "endTime": 1204.526,
        "transcript": "Atataarqu-gguq ella piunrirniaraqan yuum kanvellra cukariciquq.",
        "translation": "He said that later when the world is going to be no more, people will pass away more quickly."
    },
    "168": {
        "startTime": 1207.291,
        "endTime": 1211.241,
        "transcript": "Cali-llu-gguq ellminek, ellmeggnun akngirtaarutengluteng.",
        "translation": "He also said that they would start hurting themselves."
    },
    "169": {
        "startTime": 1213.501,
        "endTime": 1218.721,
        "transcript": "Tuaten-gguq pinanrirciqaat neplialuku, temcikluku tau͡gaam.",
        "translation": "He said that they would stop grieving over them, but laugh at them."
    },
    "170": {
        "startTime": 1220.446,
        "endTime": 1227.026,
        "transcript": "Tuani-gguq ella, piunrillra mallgikan yugni ayuqliulluta usviiruciiqukut.",
        "translation": "He said that when the world is close to being no more, we people will become foolish all the same."
    },
    "171": {
        "startTime": 1227.961,
        "endTime": 1231.641,
        "transcript": "Man'a niitelallruaqa. Maa-i piciuyugnarquq. Elitaq'la'rqa.",
        "translation": "I used to hear this. It's probably true now. I recognize it."
    },
    "172": {
        "startTime": 1231.806,
        "endTime": 1235.276,
        "transcript": "Yaantarcelluku niitelallemni wii ircaqrualallruunga.",
        "translation": "When I used to hear of the far future, my heart would skip a beat."
    },
    "173": {
        "startTime": 1235.586,
        "endTime": 1241.966,
        "transcript": "Wiinga-ll' tamakuni picurlagalriani arcaqanrulua man'a taangaq aturluku.",
        "translation": "And I was worse than those doing wrong by abusing alcohol."
    },
    "174": {
        "startTime": 1243.381,
        "endTime": 1249.171,
        "transcript": "Taangaq atullruaqa cakneq, yuilqumek-llu tekicarturqama kiingan-ll' umyuaqluku.",
        "translation": "I heavily abused alcohol, and it would be the only thing in my mind coming from the wilderness"
    },
    "175": {
        "startTime": 1250.521,
        "endTime": 1255.951,
        "transcript": "Maaten tang piunga una temlle'rqa wangnek navguallinikeka.",
        "translation": "I realized that I was destroying my old body of my own volition."
    },
    "176": {
        "startTime": 1257.651,
        "endTime": 1263.831,
        "transcript": "Ciinllugguaratka-ll' maa-i cali mat'um nalliini ukut irniama takuatni tuaten tamana-ll' atulalqa.",
        "translation": "My regret to this day is doing that in front of my children."
    },
    "177": {
        "startTime": 1264.186,
        "endTime": 1266.256,
        "transcript": "Wiinga elitnaullrullinianka.",
        "translation": "It turned out that I had taught them."
    },
    "178": {
        "startTime": 1266.776,
        "endTime": 1270.656,
        "transcript": "Uum nalliini ciinllugguaratka tamatumun arcaqertuq.",
        "translation": "Today, that is my greatest regret."
    },
    "179": {
        "startTime": 1275.561,
        "endTime": 1277.371,
        "transcript": "Iluteqaqlua-llu",
        "translation": "And I cry"
    },
    "180": {
        "startTime": 1280.491,
        "endTime": 1286.191,
        "transcript": "Atawaunrilngurmek elitnaullrulliniamki wiinga wangnek navguutekamnek waten elliquma.",
        "translation": "Becuase I had taught them something bad that would destroy me when I reached this age."
    },
    "181": {
        "startTime": 1288.016,
        "endTime": 1292.656,
        "transcript": "Ilumun-ll' au͡gkut yullret qanellrat-lli piciulallinivaa.",
        "translation": "It is amazing how true what those people said long ago."
    },
    "182": {
        "startTime": 1294.231,
        "endTime": 1299.831,
        "transcript": "Waten tang arcaqerluku cali un' qanrutek'lallrua:",
        "translation": "He would also especially talk about this:"
    },
    "183": {
        "startTime": 1301.156,
        "endTime": 1306.166,
        "transcript": "\"Agurrluku yuum akluanek tegucaqunak, ayariksaqunaku-llu.",
        "translation": "\"Never take another person's possessions, and do not covet him."
    },
    "184": {
        "startTime": 1306.526,
        "endTime": 1314.696,
        "transcript": "\"Cali-llu enemun allamun itquvet kenrraungraan wall' ussukcarraungraan tuaken tegucaqunak enemek.",
        "translation": "\"Also, if you enter another house, do not take even a single match or nail from that house."
    },
    "185": {
        "startTime": 1316.716,
        "endTime": 1324.746,
        "transcript": "\"Wall'u yuilqumi pekteng'e'rpet, camek tangenge'rpet ayariksaqunaku, teguyaqunaku.\"",
        "translation": "\"Or even if you travel in the wilderness, no matter what you see, do not covet and take it.\""
    },
    "186": {
        "startTime": 1325.246,
        "endTime": 1329.206,
        "transcript": "Yuum-gguq ellillni nalluyagucuitaa yuilqurrungraan.",
        "translation": "He said that a person never forgets what he puts even in the wilderness."
    },
    "187": {
        "startTime": 1331.401,
        "endTime": 1340.041,
        "transcript": "Man'a qanrarkaqa Kass'acetun wii elisnganrilama au͡g'umek tau͡gaam qanrutestemnek man' qanqautekaqa.",
        "translation": "Because I am not fluent in English, what I had to say was about my teacher."
    },
    "188": {
        "startTime": 1340.196,
        "endTime": 1345.876,
        "transcript": "Uum temem navguuteklinia taangaq. Maa-i-llu ilangluni iinrurrlugnek kuingirrlugnek-llu...",
        "translation": "Alcohol destroys this body. And today, it's accompanied by medicine and marijuana..."
    }
};